import Dialog from '@/components/Dialog';
import mediaQuery from '@/lib/styling/mediaQuery';
import styled from '@emotion/styled';

const PreviewDialogTitle = styled(Dialog.Title)(({ theme }) => ({
  borderBottom: `2px solid ${theme.palette.divider}`,
  display: 'flex',
  alignItems: 'center',
  '.MuiButton-root': {
    marginLeft: 36,
  },
  '.MuiIconButton-root': {
    marginLeft: 12,
    color: theme.palette.text.primary,
  },
  [mediaQuery(640)]: {
    fontSize: '1rem',
  },
}));

export default PreviewDialogTitle;
